const angular = require('angular');

const DeliveryPassService = require('./delivery-pass.service');

angular.module('wowApp.common')
    .service('DeliveryPassService', ['$q', 'Restangular', DeliveryPassService]);



// WEBPACK FOOTER //
// ./src/common/deliverypass/index.js